import React, { useEffect, useRef, useState } from "react";
import { Maximize2, Minimize2 } from "lucide-react";

export const DiagramViewport = ({ id, label, children }) => {
  const [expanded, setExpanded] = useState(false);
  const [width, setWidth] = useState(960);
  const content = useRef(null);
  useEffect(() => {
    const value = Number(content.current?.querySelector("svg")?.getAttribute("viewBox")?.split(/\s+/)[2]);
    if (Number.isFinite(value) && value > 0) setWidth(Math.max(960, value));
  }, [children]);
  return <div className="mobile-diagram" data-expanded={expanded} style={{ "--diagram-width": `${width}px` }} data-testid={`${id}-viewer`}>
    <div className="mobile-diagram-scroll" role="region" aria-label={label} tabIndex={expanded ? 0 : undefined} data-testid={`${id}-scroll`}><div ref={content} className="mobile-diagram-canvas">{children}</div></div>
    <button type="button" className="mobile-diagram-toggle" data-testid={`${id}-zoom`} aria-pressed={expanded} onClick={() => setExpanded(value => !value)}>{expanded ? <Minimize2 size={17} /> : <Maximize2 size={17} />}{expanded ? "Fit diagram" : "Enlarge diagram"}</button>
  </div>;
};